import axiosInstance from '../../../../config/axiosInstance';
import { IssuePriorityValidation } from "../../View/IssuePriority/Validation/IssuePriorityValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
    event.preventDefault();

    const formErrors = IssuePriorityValidation(formData);   
    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");

            // Create a FormData object
            const formDataToSend = new FormData();
              // Append other fields from formData
            Object.keys(formData).forEach(key => {
                if (key !== 'File') { // Skip the File key, we will handle it separately
                    formDataToSend.append(key, formData[key]);
                }
            });
            if (formData.File) {
                formDataToSend.append('File', formData.File);
            }
            const config = {
                headers: {                    
                    'Content-Type': 'multipart/form-data'
                }
            };            
            const response = await axiosInstance.post(`/SuperAdmin/CreateIssuePriorityDefault`, formDataToSend, config);
   
            setFormData({
              PriorityName: '',
              File:""
              // Reset other fields as needed
            });
            redirectRoleList();
        } catch (error) {
            console.error('Error posting data:', error);
        }
    }
};


export { handleChange, handleSubmit };
